import Skeleton from "react-loading-skeleton";

import { Badge2 } from "@/ui2/atoms/Badge";
import { Tab2 } from "@/ui2/atoms/Tab";

type NeedsReviewTabProps = {
  count: number;
  isLoading: boolean;
};

export function NeedsReviewTab({ count, isLoading }: NeedsReviewTabProps) {
  const needsReviewCount = count;

  return (
    <Tab2 id="needs-review">
      {({ isSelected }) => (
        <>
          Needs Review
          {isLoading ? (
            <CounterBadgeSkeleton />
          ) : (
            <Badge2
              appearance={isSelected ? "solid" : "outline"}
              size="xs"
              variant={isSelected ? "bright-green" : "neutral"}
            >
              {needsReviewCount}
            </Badge2>
          )}
        </>
      )}
    </Tab2>
  );
}

function CounterBadgeSkeleton() {
  return (
    <div className="tw:leading-none">
      <Skeleton className="tw:rounded-xs!" height={16} width={20} />
    </div>
  );
}
